/**
 * return TRUE if account status is NOT active
 * return TRUE if user role is not found in hash
 * return TRUE if legal agreement is not accepted
 * return TRUE if carrier is blocked
 * @param {Object} param0
 * @returns Boolean
 */
const useIsRestrictedUser = ({
  role,
  termsAccepted,
  carrier,
  accountStatus,
}) => {
  const validUser = new Map();
  validUser
    .set('first')
    .set('preferred')
    .set('admin')
    .set('owner')
    .set('dispatcher');

  // ignore accountStatus if the property is undefined
  // some accounts have not been seeded with accountStatus
  if (accountStatus !== undefined && accountStatus !== 'active') {
    return true;
  }

  return (
    !validUser.has(role.toLowerCase()) || !termsAccepted || carrier.blocked
  );
};

export default useIsRestrictedUser;
